export function buildContext({
  fentanyl,
  voc,
  pm25,
  facility = "Demo Campus",
  zone = "Unknown",
}) {
  const time = new Date();

  return {
    timestamp: time.toISOString(),
    hour: time.getHours(),
    facility,
    zone,

    signals: {
      fentanyl,
      voc,
      pm25,
    },

    flags: {
      afterHours: time.getHours() < 7 || time.getHours() > 18,
      multiSignal: fentanyl > 6,
    },
  };
}
